import React, {Suspense} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import {Routes} from './routing/Routes'
import 'bootstrap'
import 'react-phone-number-input/style.css'
import {AppThemeProvider} from '../_metronic/layout/ThemeProvider/ThemeProvider'
import {Toaster} from 'react-hot-toast'

type Props = {
  basename: string
}

const App: React.FC<Props> = ({basename}) => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <AppThemeProvider>
        <I18nProvider>
          <LayoutProvider>
            {/* @ts-ignore */}
            <AuthInit>
              {/* @ts-ignore */}
              <BrowserRouter basename={basename}>
                <Routes />
                <Toaster
                  position='top-center'
                  toastOptions={{
                    duration: 10000,
                  }}
                />
              </BrowserRouter>
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </AppThemeProvider>
    </Suspense>
  )
}

export {App}
